export abstract class BadgeGeneratorService {
    abstract getImageData(data: any, width: number, height: number): Promise<any>;
}

export function BadgeGeneratorServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('BadgeGenerator');
}

export const BadgeGeneratorServiceProvider = {
    provide: BadgeGeneratorService,
    useFactory: BadgeGeneratorServiceFactory,
    deps: ['$injector']
};
